import { render, staticRenderFns } from "./CollapseHorizontalCard.vue?vue&type=template&id=1cfd9789"
import script from "./CollapseHorizontalCard.vue?vue&type=script&lang=ts"
export * from "./CollapseHorizontalCard.vue?vue&type=script&lang=ts"
import style0 from "./CollapseHorizontalCard.vue?vue&type=style&index=0&id=1cfd9789&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports